import React from 'react';
import { adminApi } from '../admin/api';
import { STAFF_APPS } from '@/lib/staffApps';
import AppHandoff from './AppHandoff';

// The Vienna tile's landing: mint a 2-minute single-use SSO token and hand the browser to
// the Vienna app, whose /api/auth/portal redeems it against the portal backend and mints
// its own session. REACT_APP_VIENNA_URL is Vienna's public origin (e.g. https://vienna.drshumard.com).
const VIENNA_URL = (process.env.REACT_APP_VIENNA_URL || '').replace(/\/$/, '');
const VIENNA = STAFF_APPS.find((a) => a.key === 'vienna');

const mint = () => {
  if (!VIENNA_URL) throw new Error('Vienna is not configured on this portal yet.');
  return adminApi.post('/auth/vienna-token').then((r) => r.data.token);
};
const target = (token) => `${VIENNA_URL}/api/auth/portal?token=${encodeURIComponent(token)}`;

export default function ViennaLauncher() {
  return <AppHandoff app={VIENNA} mint={mint} target={target} />;
}
